import axios from "axios";
import { appConfig } from "../environment/environments";

const token = localStorage.getItem("msal.idtoken");

axios.defaults.baseURL = appConfig.api.apiUrl;
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getData = (url) => {
  return axios({
    method: "GET",
    url: url,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const putData = (url, payload) => {
  return axios({
    method: "PUT",
    url: url,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const putDataWithoutAuth = (url, payload) => {
  delete axios.defaults.headers.common["Authorization"];
  return axios({
    method: "PUT",
    url: url,
    data: payload,
  });
};

export const postData = (url, payload) => {
  return axios({
    method: "POST",
    url: url,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteData = (url, payload) => {
  return axios({
    method: "DELETE",
    url: url,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });
};
